import React, { useState } from 'react'
import _ from 'lodash'

import { Button, Divider } from '@material-ui/core'
import { ArrowDropDown, ArrowRight } from '@material-ui/icons'
import NoDataFoundMessage from 'ui/views/Home/NoDataFoundMessage'
import { booleanToText, formatBRL } from 'utils/functions'
import Container from '../SingleTableIncome/styles'
import { sectionsInfo } from '../SingleTableIncome/sectionsInfo'

const DependentsInfo = ({ irDeclaration, isExportingPDF }) => {
  const sectionId = 'dependents_info'
  const sectionData = irDeclaration[sectionId]
  const sectionMetadata = sectionsInfo[sectionId]
  const sectionColumns = sectionMetadata?.columns || {}
  const [showItems, setShowItems] = useState(true)

  const getTrClassBasedOnIndex = (index) => (index % 2 === 1 ? 'tr-zebra' : null)

  const formatValue = (dataType, value) => {
    if (value == null) {
      return '-'
    }

    if (dataType === 'currency') {
      return formatBRL(value)
    }

    if (dataType === 'boolean') {
      return booleanToText(value)
    }

    return value
  }

  const renderRowColumns = (row) => {
    return _.map(sectionColumns, (column, key) => (
      <td key={key}>{formatValue(column.type, row[key])}</td>
    ))
  }

  const renderSectionItems = () => {
    const items = sectionData?.items || []
    if (_.isEmpty(items)) {
      return null
    }

    return (
      <div className="table-container">
        <table className="main-table">
          <thead>
            <tr>
              {_.map(sectionColumns, (column, key) => (
                <th key={key}>{column.name}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {_.map(items, (row, index) => (
              <tr className={getTrClassBasedOnIndex(index)} key={row.id || `${row.cpf}-${index}`}>
                {renderRowColumns(row)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }

  return (
    <Container>
      <h2>{sectionMetadata?.name}</h2>
      {_.isEmpty(sectionData) ? (
        <NoDataFoundMessage />
      ) : (
        <div>
          <div className="values-data-container">
            <p>
              <span>{`${sectionMetadata?.total_deduction_value?.name}: `}</span>
              <span className="total-correct">
                {formatValue('currency', sectionData?.total_deduction_value)}
              </span>
            </p>
          </div>

          <div className="values-files-container">
            <Button
              startIcon={showItems  ? <ArrowDropDown /> : <ArrowRight />}
              onClick={() => setShowItems(!showItems)}
            >
              <strong style={{ fontSize: '1.34rem' }}>
                {showItems ? 'Esconder itens' : 'Exibir itens'}
              </strong>
            </Button>

            {(showItems || isExportingPDF) && (
              <div className="values-file-container">
                {renderSectionItems()}
                <Divider />
                <br />
              </div>
            )}
          </div>
        </div>
      )}
    </Container>
  )
}

export default DependentsInfo
